import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LATVIJA_LV_AUTH } from '../../../router/routes';
import juridicalImage from './juridical.svg';
import physicalImage from './physical.svg';
import css from './index.module.css';

export default function Step1() {
  const { t } = useTranslation();
  const [legal, setLegal] = useState(null);

  const onChoice = (choice: string) => {
    const registerUrl = `${LATVIJA_LV_AUTH}?action=register`;

    if (choice === 'legal') {
      setLegal(true);
      window.location.assign(`${registerUrl}&legal=true`);
    } else {
      setLegal(false);
      window.location.assign(`${registerUrl}&legal=false`);
    }
  };

  const physicalClasses = css['legal'].concat(
    ` ${legal === false ? css['active'] : ''} `
  );
  const juridicalClasses = css['legal'].concat(
    ` ${legal === true ? css['active'] : ''} `
  );

  return (
    <div>
      <h1>{t('pages.external.register.title')}</h1>

      <p className={css['description']}>
        {t('pages.external.register.step1.info')}
      </p>

      <div
        data-name="physical"
        className={physicalClasses}
        onClick={() => onChoice('physical')}
      >
        <img src={physicalImage} alt="" className="mb-3" />
        <span>{t('pages.external.register.step1.physical')}</span>
      </div>

      <div
        data-name="legal"
        className={juridicalClasses}
        onClick={() => onChoice('legal')}
      >
        <img src={juridicalImage} alt="" className="mb-3" />
        <span>{t('pages.external.register.step1.juridical')}</span>
      </div>
    </div>
  );
}
